/* eslint-disable prefer-destructuring */
import Url from 'url-parse';

class CultureUrls {

  constructor() {
    const links = document.querySelectorAll('a');

    const lang = document.documentElement.lang;

    // Only need to run this for Spanish culture
    if (lang !== 'en') {
      if (links.length > 0) {
        for (let i = 0; i < links.length; i++) {
          if (links[i] != null && !links[i].hasAttribute('data-ignore-leaving-site')) {

            // Check to see if the link is already using /es
            const link = Url(links[i]);

            if (link.hostname === window.location.hostname) {

              let pathSub = link.pathname.substring(0, 4);

              if (!link.pathname.includes('/getmedia/') && !link.pathname.includes('configuration-items/')) {
                if (pathSub !== '/es/' && link.hash === '' && link.pathname !== '/es') {
                  if (pathSub !== '/') {
                    links[i].href = `/es${link.pathname}${link.query}`;
                  }
                }
              }

            }
          }
        }
      }
    }
  }
}

new CultureUrls();
